module.exports = __webpack_public_path__ + "static/img/store.105b413e.jpg";